@if (false) {
  <div class="navbar-top" [ngClass]="fuseConfig()?.layout.navbar.secondaryBackground">
    <div class="logo">
      <!--<img class="logo-icon" src="assets/images/logos/fuse.svg">-->
      <!--<span class="logo-text secondary-text">FUSE</span>-->
      <!--<img class="logo-icon" src="assets/images/logos/r2/medium/r2-cloud-robo-medium.png">-->
      <!--<img class="logo-img-text" src="assets/images/logos/r2/medium/r2-cloud-logo-texto-white.png">-->
    </div>
    <div class="buttons">
      <button mat-icon-button class="toggle-sidebar-folded"
        (click)="toggleSidebarFolded()">
        <mat-icon class="secondary-text">menu</mat-icon>
      </button>
      <button mat-icon-button class="toggle-sidebar-opened"
        (click)="toggleSidebarOpened()">
        <mat-icon class="secondary-text">arrow_back</mat-icon>
      </button>
    </div>
  </div>
}


<div class="navbar-scroll-container" [ngClass]="fuseConfig()?.layout.navbar.primaryBackground"
  style="overflow-x: hidden">

  @if (false) {
    <div class="user flex-col" [ngClass]="fuseConfig()?.layout.navbar.secondaryBackground">
      <div class="h3 username">Charlie Adams</div>
      <div class="h5 email hint-text mt-8">adams.charlie&#64;mail.com</div>
      <div class="avatar-container" [ngClass]="fuseConfig()?.layout.navbar.primaryBackground">
        <img class="avatar" src="assets/images/avatars/Velazquez.jpg">
      </div>
    </div>
  }

  <div class="navbar-content">
    <fuse-navigation class="material2" layout="vertical"></fuse-navigation>
  </div>

</div>
